import React from 'react';
import { GROUP, DIVISIONS } from '../../CompanyInfo';
import './ContactUs.css';

/**
 * Contact Us.
 *
 * Was a two-column page where every division printed its address, its bank
 * table and a 150px payment QR in full, next to a 450px map - four or five
 * screens of scrolling for what is really a short list of addresses and phone
 * numbers.
 *
 * The three divisions are now equal cards side by side. Bank accounts and
 * payment QRs are not shown here - they are customer-only, on the Account
 * Info screen after login.
 *
 * Each card carries its OWN map. There used to be one map for the page,
 * pointing at the Udupi head office, which left the Shimoga branch and
 * Vetrem Pharma with an address and no way to see where it is.
 */

const telHref = (phone) => 'tel:' + phone.replace(/[^0-9+]/g, '');

/* the place to look up - an explicit query per division, from CompanyInfo,
   rather than a guess stitched together from the address lines */
const mapQuery = (d) =>
    d.mapQuery ||
    [d.name, ...d.addressLines, d.city, d.state, d.pincode]
        .filter(Boolean)
        .join(', ');

const mapEmbed = (d) =>
    'https://www.google.com/maps?q=' + encodeURIComponent(mapQuery(d)) + '&output=embed';

const mapLink = (d) =>
    'https://www.google.com/maps/search/?api=1&query=' +
    encodeURIComponent(mapQuery(d));

const DivisionCard = ({ d }) => (
    <article className='ctCard'>
        <header className='ctCardHead'>
            <img src={d.logo} alt={d.name} className='ctLogo' />
            <div className='ctNames'>
                <h5 className='ctName'>{d.name}</h5>
                <span className='ctLabel'>{d.label}</span>
            </div>
        </header>

        {/* one paragraph rather than a line per line of the address */}
        <address className='ctAddress'>{d.addressLines.join(', ')}</address>

        <div className='ctPhones'>
            {d.phones.map((phone) => (
                <a key={phone} className='ctPhone' href={telHref(phone)}>
                    {phone}
                </a>
            ))}
        </div>

        <a className='ctEmail' href={'mailto:' + d.email}>
            {d.email}
        </a>

        <dl className='ctMeta'>
            <div className='ctMetaRow'>
                <dt>GST</dt>
                <dd>{d.gst}</dd>
            </div>
            <div className='ctMetaRow'>
                <dt>Drug Lic.</dt>
                <dd>{d.drugLicences.join(', ')}</dd>
            </div>
        </dl>

        <div className='ctMapWrap'>
            <iframe
                src={mapEmbed(d)}
                className='ctMap'
                title={d.name + ' - ' + d.label + ' location'}
                loading='lazy'
                referrerPolicy='no-referrer-when-downgrade'
            />
        </div>

        <a
            className='ctDirections'
            href={mapLink(d)}
            target='_blank'
            rel='noopener noreferrer'
        >
            Open in Google Maps
        </a>

    </article>
);

const ContactUs = () => (
    <div className='contactPage'>
        <div className='ctHead'>
            <h3 className='ctTitle'>Contact Us</h3>
            <p className='ctSub'>
                {GROUP.name} &middot; {GROUP.since}
            </p>
        </div>

        <div className='ctGrid'>
            {DIVISIONS.map((d) => (
                <DivisionCard key={d.key} d={d} />
            ))}
        </div>
    </div>
);

export default ContactUs;
